import { useState, useEffect, useRef } from "react";
import { api, fileUrl } from "../lib/api";
import { FileText } from "lucide-react";

// Renders image/video/audio. Owner mode = blob fetch (bearer). Guardian mode = direct URL with token.
const AuthMedia = ({ item, guardianToken, className }) => {
  const [blobUrl, setBlobUrl] = useState(guardianToken ? fileUrl(item.storage_path, guardianToken) : null);
  const objUrlRef = useRef(null);
  const [posterUrl, setPosterUrl] = useState(guardianToken && item.poster ? fileUrl(item.poster, guardianToken) : null);
  const posterRef = useRef(null);

  useEffect(() => {
    if (guardianToken) return;
    let active = true;
    api.get(`/files/${item.storage_path}`, { responseType: "blob" }).then((res) => {
      if (!active) return;
      const url = URL.createObjectURL(res.data);
      objUrlRef.current = url;
      setBlobUrl(url);
    }).catch(() => {});
    return () => {
      active = false;
      if (objUrlRef.current) URL.revokeObjectURL(objUrlRef.current);
    };
  }, [item.storage_path, guardianToken]);

  useEffect(() => {
    if (guardianToken || !item.poster) return;
    let active = true;
    api.get(`/files/${item.poster}`, { responseType: "blob" }).then((res) => {
      if (!active) return;
      const url = URL.createObjectURL(res.data);
      posterRef.current = url;
      setPosterUrl(url);
    }).catch(() => {});
    return () => { active = false; if (posterRef.current) URL.revokeObjectURL(posterRef.current); };
  }, [item.poster, guardianToken]);

  if (!blobUrl) return <div className={`bg-[#F0E9DC] animate-pulse ${className}`} />;
  if (item.kind === "video") return <video src={blobUrl} poster={posterUrl || undefined} controls className={className} data-testid="media-video" />;
  if (item.kind === "audio") return <audio src={blobUrl} controls className="w-full" data-testid="media-audio" />;
  if (item.kind === "file")
    return (
      <a href={blobUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-primary hover:underline" data-testid="media-file">
        <FileText className="w-4 h-4" /> {item.original_filename || "Apri documento"}
      </a>
    );
  return <img src={blobUrl} alt={item.original_filename} className={className} data-testid="media-image" />;
};

export default AuthMedia;
